(function ($) { 
    $('.devamini-oku').on('click',function(e){
        var sectionID = $($(this).attr('href'));
        if(sectionID.length){
            e.preventDefault();        
            var scrollPos = sectionID.offset().top;
            $("html, body").animate({ 
                scrollTop: scrollPos - 120 
            }, 600);
        }
    });
})(jQuery);